import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

import { appRoute } from '@/app'
import { appState } from '@/appState'

export const rootRoute = createRoute({
    getParentRoute: () => appRoute,
    path: '/user',
    component: lazyRouteComponent(() => import('./Root'), 'Root'),
    beforeLoad: async ({ location }): Promise<void> => {
        if (!location.pathname.split('/')[2]) {
            throw redirect({
                replace: true,
                to: '/user/start',
            })
        }
    },
    onEnter: () => {
        appState.setTenant(null)
    },
})
